import { log } from '@/log'
import { GameResult } from '@/models/game/response/result'
import { Either, Left, Right } from 'fp-ts/lib/Either'
import { ApiClientWithAuth } from './client'
import { ApiService } from './service'

const namespace: string = 'game-result'

export default class GameResultApiService extends ApiService {

  async get(
    campaignId: string,
    brandEnglishName?: string
  ): Promise<Either<Error, GameResult>> {
    const endpoint = this.makeGameResultEndpoint(campaignId, brandEnglishName)

    try {
      const response = await ApiClientWithAuth.get(endpoint)
      log.debug({ service: `${ namespace }/get${ endpoint }`, response })

      return new Right(new GameResult(response.body.data))
    } catch (error) {
      log.error({ service: `${ namespace }/get${ endpoint }`, error })

      return new Left(error)
    }

  }

  private makeGameResultEndpoint(campaignId: string, brandEnglishName?: string): string {

    if (brandEnglishName && brandEnglishName.length > 0) {

      return `/api/user/${ brandEnglishName }/game/result/${ campaignId }`
    }

    return `/api/user/game/result/${ campaignId }`
  }
}
